import BaseUpdateRequest from "@/models/Shared/BaseUpdateRequest";

export default class UpdateBookingGeneralDetailsRequest extends BaseUpdateRequest {
    ownerId: string;
    branchId: string;
    isTest = false;
    testEmailAddresses = '';
    purchaseOrderNumber = '';
    instructions = '';
}